import { Timestamp } from "firebase/firestore";

/**
 * Formulário → Firestore
 */
export const automationToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const base = {
        idTenant,
        trigger: data.trigger,
        name: data.name?.trim() || "",
        channel: data.channel,
        message: data.message?.trim() || "",
        delayDays: parseInt(data.delayDays, 10) || 0,
        delayHours: parseInt(data.delayHours, 10) || 0,
        scheduledTime: data.scheduledTime,
        active: data.active !== undefined ? data.active : true,

        updatedAt: Timestamp.now(),
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    if (!data.id) {
        base.createdAt = Timestamp.now();
        base.createdBy = {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        };
    }

    return base;
};

/**
 * Firestore data (raw) → React
 */
export const automationDataFromFirestore = (id, data) => {
    if (!data) return null;

    return {
        id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
